import DriveView from "../../DriveView";

export default class DebugPageView extends DriveView<Backbone.Model> {}